import Api from './Api';

const all = (payload) => {
    const path = '/jobs-history';
    const endpoint = payload ? `${path + '?' + Object.keys(payload).map(key => key + '=' + payload[key]).join('&')}` : path;

    return Api.getRequest({
        endpoint
    });
};

const republishLogsAll = (payload) => {
    const path = '/republish-logs/all';
    const endpoint = payload ? `${path + '?' + Object.keys(payload).map(key => key + '=' + payload[key]).join('&')}` : path;

    return Api.getRequest({
        endpoint
    });
};

const republishMarkedAsRead = (payload) => {
    return Api.postRequest({
        endpoint: `/republish-logs/marked-as-read`,
        method: 'PUT',
        data: payload
    });
}

export default {
    all,
    republishLogsAll,
    republishMarkedAsRead
};